import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {lazyRegister} from "@core/lazyRegister";
import {ProductService} from "@services/ProductService";

export class ProductTagService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }
    
    GetTags(query) {
        return this.baseApiFactory.getData<any[]>('/api/ProductTag', query );
    };

    InsertTags(values) {
        return this.baseApiFactory.post('/api/ProductTag', values);
    };

    UpdateTags(value) {
        return this.baseApiFactory.put('/api/ProductTag', value);
    };

    DeleteTags(id) {
        return this.baseApiFactory.delete('/api/ProductTag/' + id);
    };
}

lazyRegister.service('ProductTagService', ProductTagService);